<template>
<div class="main">
  <homeBanner></homeBanner>
  <homeComponent></homeComponent>
  <footerComponent></footerComponent>
</div>
</template>

<script>
import homeBanner from '/components/pc/headerComponent/homeBanner.vue'
import homeComponent from '/components/pc/homeComponent/homeComponent.vue'
import footerComponent from '/components/pc/footerComponent/footerComponent.vue'
import tabInfo from '/js/navList/navList.js'
export default {
  components:{
    homeBanner,
    homeComponent,
    footerComponent,
  },
    data() {
      return {
          activeName: 'first',
          swiperList:[
            {img:'/static/img/banner/home.jpeg'}
          ]
      };
    },
    created() {
      this.tabList = tabInfo.tabList
    },
    mounted(){
      
    },
    methods: {
      tabClickEvent(name) {
        this.activeName = name
        if(name == 'second'){
          this.$router.push('/productContent')
        }else if(name == 'third'){
          this.$router.push('/aboutUs')
        }else if(name == 'fourth'){
          this.$router.push('/moveNow')
        }
      },
    }
  };
</script>

<style scoped lang="scss">

</style>
